import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { getVitals, getVitalsReference } from "../../lib/api";
import { useStore } from "../../store";

import VitalCard from "./vitalCard";
import { useQuery } from "@tanstack/react-query";
import VitalDetails from "./vitalDetails";

const VitalSummary = () => {
  let navigate = useNavigate();
  const vitalSession = useStore((state) => state.selectedVitals);
  const [vitalData, setVitalData] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const [vitalArray, setVitalArray] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [vitalDetails, setVitalDetails] = useState(null);

  const getVitalInfo = async () => {
    try {
      const patientId = localStorage.getItem("patientId");
      if (!patientId) {
        setLoading(false);
        return;
      }
      // const vitalSession = sessionStorage.getItem('currentVitals') ? JSON.parse(sessionStorage.getItem('currentVitals')):null;
      if (vitalSession) {
        setVitalData(vitalSession?.data);
        setLoading(false);
        return;
      }
      setLoading(true);
      const res = await getVitals({ patientId });
      const result = res?.data?.result;
      const vitalDetails = result?.[0]?.data;
      if (result?.[0])
        sessionStorage.setItem("currentVitals", JSON.stringify(result[0]));
      setVitalData(vitalDetails);
      setLoading(false);
      // console.log(vitalDetails, "vit");
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVitalInfo();
  }, []);
  const { data, isLoading: vitalLoading } = useQuery({
    queryKey: ["vitalRef"],
    queryFn: () => getVitalsReference(),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });

  const vitalInfos = data?.data?.result || [];

  useEffect(() => {
    if (!vitalData || !vitalInfos) return;
    // console.log(vitalData, "vitala");
    const mergedArray = Object.entries(vitalData)
      .filter(([key, value]) => value && value.value !== null)
      .map(([key, measurement]) => {
        const vitalInfo = vitalInfos.find(
          (info) => info.abbreviation.toLowerCase() === key.toLowerCase()
        );
        if (vitalInfo) {
          const { unit, value } = measurement;
          return { ...measurement, ...vitalInfo };
        }
      });
    mergedArray?.sort((a, b) => a.display_order - b.display_order);
    // console.log(mergedArray, "mergearra");
    const vitalList = mergedArray;
    setVitalArray(vitalList || []);
  }, [vitalData, vitalInfos]);

  const handleGoBack = () => {
    navigate(-1);
  };

  const closeShowDetails = () => {
    setShowDetails(false);
  };
  const showDetailTab = (vital) => {
    setShowDetails(true);
    setVitalDetails(vital);
  };
  return (
    <div className="bg-gray-50 min-sh-screen">
      {!showDetails && (
        <div className="flex text-black p-4 pt-6 h-16 fixed max-w  z-50 w-full bg-gray-50 ">
          <div>
            <Link onClick={handleGoBack}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="2"
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
                />
              </svg>
            </Link>
          </div>
          <div className="pl-2 flex-1 mt-0.5">
            <h4 className="font-semibold text-sm">Back</h4>
          </div>
        </div>
      )}

      <div
        className={` flex-1 overflow-scroll hideScroll  text-gray-500flex flex-col  p-4 ${
          showDetails ? "" : "pt-16"
        }`}
      >
        <div className="text-blue-800 text-lg font-extrabold font-['SF Pro Display'] uppercase my-3">
          Your Vital Summary
        </div>
        {!isLoading ? (
          vitalData ? (
            showDetails ? (
              <VitalDetails
                closeShowDetails={closeShowDetails}
                vital={vitalDetails}
              />
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3  flex-wrap flex-1  ">
                {vitalArray.map((vital, index) => {
                  if (vital?.display_name) {
                    return (
                      <VitalCard
                        key={index}
                        vital={vital}
                        index={index}
                        showDetailTab={showDetailTab}
                        onEdit={setVitalData}
                      />
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
            )
          ) : (
            <p className="text-lg font-semibold text-center mt-4">
              No data available
            </p>
          )
        ) : (
          <div className=" gap-3 md:gap-3 flex-wrap flex-1  sm:justify-normal grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
            {" "}
            <div className="animate-pulse flex flex-col cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300 ">
              <div className="m-2 w-full  bg-slate-200 h-4"></div>
              <div className="m-2  w-full  bg-slate-200 h-2"></div>
            </div>
            <div className="animate-pulse flex flex-col cursor-pointer p-4 w-full justify-center items-center  bg-gradient-to-r from-white to-zinc-100 rounded-lg border border-neutral-300">
              <div className="m-2 w-full  bg-slate-200 h-4"></div>
              <div className="m-2  w-full  bg-slate-200 h-2"></div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VitalSummary;
